import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { Delivery } from 'my-lib-sanfelici/my-lib-sanfelici';
import { DeliveryService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-delivery-details',
  templateUrl: './delivery-details.component.html',
  styleUrls: ['./delivery-details.component.scss']
})
export class DeliveryDetailsComponent implements OnInit {
id: string;
delivery: Observable<Delivery>;
  constructor(
    private router: Router,
    private db: AngularFirestore,
    private deliveryservice: DeliveryService,
    private route: ActivatedRoute) { }
    cancella(id){
      this.deliveryservice.delete(id)
    .then(() => this.router.navigate(['/myuser', 'delivery', 'details', id]));

    }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.delivery = this.deliveryservice.get(this.id);
    this.delivery.subscribe(d=>{
      if(d){}else{
        this.router.navigate(['/myuser', 'delivery', 'create', this.id]);
      }
    });
  }

}
